module.exports = __webpack_public_path__ + "static/media/phone-white.f77d98eb.svg";